import useTranslator from "../../hooks/useTranslator";
import {
  CircularProgressbarWithChildren,
  buildStyles,
} from "react-circular-progressbar";
import Slider from "rc-slider";
import "rc-slider/assets/index.css";
import "rc-tooltip/assets/bootstrap.css";
import "react-circular-progressbar/dist/styles.css";
import "react-circular-progressbar/dist/styles.css";
import VectorIcon from "../../assets/img/VectorIcon1.svg";
import Twotone2 from "../../assets/img/ic_twotone-euro2.svg";
import UserIcon from "../../assets/img/user-icon-gray.svg";
import notIcon from "../../assets/img/noticIcon.svg";
import moreInfoimg from "../../assets/img/moreInfoimg.svg";
import { useContext, useEffect, useState } from "react";
import {
  calculateEffortRatePercentageTenant,
  convertCurrencyFormat,
  getRentPercentage,
  haveValue,
  toast,
} from "../../helper/common";
import moment from "moment";
import TotalSalaryModal from "./TotalSalaryModal";
import UpdatedIncomeSourceModal from "./UpdateIncomeSourceModal";
import ConnectBankCard from "./ConnectBankCard";
import FinancialInfoModal from "./FinancialInfoModal";
import LandLordContext from "../../context/landlord/LandLordContext";
import AuthContext from "../../context/auth/AuthContext";
import BankModal from "../../pages/onboarding/BankModal";
import LandlordBankCard from "./LandlordBankCard";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { WORKSPACE_ROLES_CAPABILITIES } from "../../Utils/workspaceRoleCapabilities";
import ButtonActionTooltip from "../ErrorModal/ButtonActionTooltip";

const DetailsSkor = (props) => {
  const {
    user = {},
    combinedIncome = 0,
    effortObj,
    handleSaveEffortRateData = () => {},
    userIncome = {},
    gurantorsIncome = {},
    handleIncomeChange,
    totalIncomeModal,
    setTotalIncomeModal,
    showReportIcons,
    handleFinancialIncomeChange,
    selectedFinancialIncomeSourceData,
    selectedSources,
    setSelectedSources,
    loadFullInfo,
    isGuarantor,
    paymentScoreLoading,
    setPaymentScoreLoading,
    Bankshow,
    setBankshow,
    reconnectFlow,
    setReconnectFlow,
    updateTenantData,
    scoreValue,
    setScoreValue,
    getAnalysisDetails,
    financial_info_errors,
    setFinancial_info_errors,
    profileId,
    excluded_income_source_ids,
    isFromReport = false,
    effortRateType,
    setEffortRateType,
    totalGuarantorIncome,
    showEffortRateCalcuator,
    setShowEffortRateCalcuator,
    fullinfo,
    fullInfoForGurantor,
    guarantor_id,
    totalGurantorIncomeForTable,
    combinedIncomeForTable,
    llShowOnly,
  } = props;
  const { _t } = useTranslator();
  const [isHovered, setIsHovered] = useState(false);
  const {
    getTinkReportData,
    sendFinancialInfoRemainder,
    deleteCustomIncomeSource,
  } = useContext(LandLordContext);
  const { setLoading, user: originalUser } = useContext(AuthContext);
  const isUserTenantCheck =
    user?.role != "tenant" && user?.role != "emailTenant";

  const [updateIncomeSourceModal, setUpdateIncomeSourceModal] = useState(false);
  const maxValue = 1000;
  const [value, setValue] = useState(0);
  const [ieScore, setIeScore] = useState(null);

  const [isSkorExpired, setIsSkorExpired] = useState(false);
  const [updateSourceObj, setUpdateSourceObj] = useState([]);
  const [financialInfoModal, setFinancialInfoModal] = useState(false);
  const [sendRemainderLoading, setSendRemainderLoading] = useState(false);
  const [propertyRent, setPropertyRent] = useState("");

  const handleDeleteCustomIncome = async (customSourceId, userType, userId) => {
    const id =
      (fullinfo?._id?.$oid || fullinfo?._id) ??
      fullinfo?.tenant_id?.profileId ??
      profileId;
    const tenantId = fullinfo?.tenantid?._id;
    const targetIsGuarantor = userType === "guarantor" || isGuarantor;
    const specificGuarantorId =
      targetIsGuarantor && userId ? userId : guarantor_id;
    try {
      const payload = {
        tenantid: tenantId,
        target_type: targetIsGuarantor ? "guarantor" : "tenant",
        guarantor_id: targetIsGuarantor ? specificGuarantorId : undefined,
      };
      const res = await deleteCustomIncomeSource(id, customSourceId, payload);
      if (res?.status === "success") {
        toast.success(
          _t("customIncomeDeleted", "Custom income deleted successfully")
        );
        await loadFullInfo();
      } else {
        toast.error(
          _t("failedToDeleteCustomIncome", "Failed to delete custom income")
        );
      }
    } catch (err) {
      toast.error(
        _t("failedToDeleteCustomIncome", "Failed to delete custom income")
      );
    }
  };

  useEffect(() => {
    if (haveValue(scoreValue) && haveValue(maxValue)) {
      setValue((scoreValue / maxValue) * 100);

      const dateToCheck = haveValue(user?.bankVerificationDate)
        ? user.bankVerificationDate
        : user?.created_at;

      const expiryDate = moment(dateToCheck).add(2, "months");

      const isExpired = expiryDate.isBefore(moment(), "day");

      setIsSkorExpired(isExpired);
    }
  }, [scoreValue]);

  useEffect(() => {
    if (!haveValue(ieScore) && user?.ie_verified) {
      calculateIeScore();
    }
    const temp_score = user?.paymentScores?.creditScore?.value;
    if (haveValue(temp_score) && !paymentScoreLoading) {
      setScoreValue(temp_score);
    } else {
      setScoreValue(null);
    }
  }, [user, ieScore, paymentScoreLoading]);

  const calculateIeScore = () => {
    var totalScore = (user?.paymentScores?.creditScore?.value || 0) / 2;

    if (user?.ie_verified) {
      if (totalScore >= 600) {
        totalScore += 200;
      } else {
        totalScore += 400;
      }
    }
    if (totalScore > 850) {
      totalScore = 850;
    }
    setIeScore(totalScore);
  };

  const getProgressColor = (percentage) => {
    if (percentage < 20) return "#F3483E";
    if (percentage < 40) return "#F77841";
    if (percentage < 60) return "#F8E002";
    if (percentage < 80) return "#99DE04";
    return "#05C200";
  };

  const Handle = Slider.Handle;

  const returnSkorStatus = () => {
    const skor = user?.paymentScores?.creditScore?.value;
    if (skor <= 200) {
      return <h2 className="UnstableText">{_t("unstable")}</h2>;
    } else if (skor >= 201 && skor <= 400) {
      return <h2 className="VariableText">{_t("variable")}</h2>;
    } else if (skor >= 401 && skor <= 600) {
      return <h2 className="StableText">{_t("stable")}</h2>;
    } else if (skor >= 601 && skor <= 800) {
      return <h2 className="ReliableText">{_t("reliable")}</h2>;
    } else if (skor >= 800) {
      return <h2 className="ExtremelyText">{_t("extremelyReliable")}</h2>;
    }
  };

  const [efforRateLocal, setEfforRateLocal] = useState(35);
  const [effortRateData, setEffortRateData] = useState(effortObj);
  const [allGuarantorSources, setAllGuarantorSources] = useState([]);

  useEffect(() => {
    setEffortRateData(effortObj);
    setEfforRateLocal(effortObj?.effort_rate ?? 30);
    setEffortRateType(
      haveValue(user?.effort_rate_type) && !isGuarantor
        ? user?.effort_rate_type
        : isGuarantor
          ? "guarantor"
          : "tenant"
    );

    let effortRateType = "tenant";
    let effortRateValue =
      effortObj?.effort_rate ??
      originalUser?.current_workspace?.default_effort_rate ??
      35;

    if (
      llShowOnly &&
      (fullinfo?.effort_rate_data || fullInfoForGurantor?.effort_rate_data)
    ) {
      // GUARANTOR (always guarantor)
      if (isGuarantor) {
        const guarantorData =
          fullInfoForGurantor?.effort_rate_data?.guarantor?.get?.(
            guarantor_id
          ) || fullInfoForGurantor?.effort_rate_data?.guarantor?.[guarantor_id];

        effortRateType = "guarantor";
        effortRateValue =
          guarantorData?.effort_rate_percentage ??
          effortObj?.effort_rate ??
          originalUser?.current_workspace?.default_effort_rate ??
          35;
      }
      // TENANT
      else {
        effortRateType =
          fullinfo?.effort_rate_data?.tenant?.effort_rate_type ?? "tenant";

        effortRateValue =
          fullinfo?.effort_rate_data?.tenant?.effort_rate_percentage ??
          effortObj?.effort_rate ??
          originalUser?.current_workspace?.default_effort_rate ??
          35;
      }
    }
    // 🔹 NON landlord view (existing behavior)
    else {
      effortRateType =
        haveValue(user?.effort_rate_type) && !isGuarantor
          ? user?.effort_rate_type
          : isGuarantor
            ? "guarantor"
            : "tenant";

      effortRateValue = effortObj?.effort_rate ?? 35;
    }

    setEffortRateType(effortRateType);
    setEfforRateLocal(effortRateValue);
  }, [user, effortObj?.effort_rate]);

  useEffect(() => {
    const guarantorSources = gurantorsIncome?.map((item) => ({
      _id: item?.all_sources?._id,
      all_sources: item?.all_sources,
      current_selected: item?.source,
      current_income_mode: item?.source_mode,
      type: "guarantor",
    }));
    setAllGuarantorSources(guarantorSources);
  }, [gurantorsIncome]);

  useEffect(() => {
    setEffortRateData(
      calculateEffortRatePercentageTenant(combinedIncome, user, efforRateLocal)
    );
  }, [efforRateLocal, combinedIncome]);

  // in your onChange handler
  const handleChangeEffortRate = (val) => {
    setEfforRateLocal(val);
  };

  const handleChangeEffortRateApiCall = (data) => {
    const _data = {
      effort_rate_percentage: data,
      type: "percentage",
      tenant_id: user?._id,
    };
    handleSaveEffortRateData(_data);
  };

  const handleUpdateEffortRateType = (data) => {
    const _data = {
      effort_rate_type: data,
      type: "effortRateType",
      tenant_id: user?._id,
    };
    handleSaveEffortRateData(_data);
  };

  const handleOpenFinancialInfoModal = () => {
    if (
      haveValue(user?.tenant_extra_field_id?.tink_report_data) &&
      Object.keys(user?.tenant_extra_field_id?.tink_report_data).length > 0 &&
      user?.tenant_extra_field_id?.tink_report_data?.status != "failed"
    ) {
      setFinancialInfoModal(true);
    } else {
      setLoading(true);
      getTinkReportData(user?._id)
        .then(async (res) => {
          await loadFullInfo();
          setLoading(false);
          setFinancialInfoModal(true);
        })
        .catch((err) => {
          setLoading(false);
        });
    }
  };

  const handleSendRemainder = async (purpose) => {
    try {
      setSendRemainderLoading(true);
      let payload = {
        tenant_id: user?._id,
      };
      if (purpose === "forExpiryFinancialData") {
        payload.purpose = "forExpiryFinancialData";
      }
      const res = await sendFinancialInfoRemainder(payload);
      if (res?.success) {
        toast.success(
          _t("remainderSent", "Text used if to send remainder success")
        );
      } else {
        toast.error(
          _t("failedToSendRemainder", "Text used if failed to send remainder")
        );
      }
    } catch (error) {
      toast.error(
        _t("failedToSendRemainder", "Text used if failed to send remainder")
      );
    } finally {
      setSendRemainderLoading(false);
    }
  };

  const effortRateToggleOptions = ["tenant", "guarantor", "both"];

  const handleClick = (option) => {
    setEffortRateType(option);
    handleUpdateEffortRateType(option);
  };

  const getEffortColor = (value) => {
    if (value >= 1 && value <= 35) return "#99DE04"; // green
    if (value > 35 && value <= 45) return "#F77841"; // yellow-orange
    if (value > 45) return "#F3483E"; // red
    return "#7F7F7F"; // fallback
  };

  const min = 10,
    max = 50;

  useEffect(() => {
    if (haveValue(propertyRent)) {
      const combinedPercentage = getRentPercentage(
        combinedIncomeForTable,
        propertyRent
      )?.exactValue;

      // clamp between 10 and 50
      const cappedPercentage = Math.min(Math.max(combinedPercentage, 10), 50);

      handleChangeEffortRate(cappedPercentage);
      handleChangeEffortRateApiCall(cappedPercentage);
    }
  }, [propertyRent]);

  return (
    <>
      <div className="row mainEffortRateWrapper">
        <div className="col-md-6">
          <div className="Profile_summary2 skorsetbox p-3">
            <div className="d-flex justify-content-between flex-wrap w-100">
              {/* <div className="effort-rate-info w-100"> */}
              <div className="d-flex justify-content-between w-100 flex-wrap">
                <h4 className="mb-0">{_t("setEffortRate")}</h4>
                {!showEffortRateCalcuator && (
                  <div className="effortRateToggleContainer">
                    {effortRateToggleOptions.map((option) => {
                      const isDisabled =
                        user?.gurantor_id?.filter(
                          (val) => val?.forensic_status === "COMPLETED"
                        )?.length === 0 &&
                        [isGuarantor ? "tenant" : "guarantor", "both"].includes(
                          option
                        );

                      return (
                        <div
                          style={{ display: "inline-block" }}
                          data-tooltip-id={
                            isDisabled ? "button-action-tooltip" : undefined
                          }
                          key={option}
                        >
                          <div
                            className={`effortRateeBtn
          ${effortRateType === option ? "active" : ""}
          ${isDisabled ? "disabled pe-none" : ""}
        `}
                            onClick={() => !isDisabled && handleClick(option)}
                          >
                            {_t(option)}
                          </div>

                          {isDisabled && <ButtonActionTooltip />}
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
              {!llShowOnly ? (
                <p>{_t("landlordsTypicallyPreferEffortRatesBelow")}</p>
              ) : (
                <div className="d-flex align-items-center justify-content-between w-100 flex-wrap">
                  <p>{_t("keyFinancialMetricsForYourRentalSituation")}</p>

                  {showEffortRateCalcuator && (
                    <div className="property-rent-field">
                      {_t("propertyRent")}:
                      <div className="property-rent-field-input">
                        <span style={{ fontWeight: "700" }}>€</span>
                        <input
                          style={{ border: "0" }}
                          placeholder="0"
                          type="text"
                          value={propertyRent}
                          onChange={(e) => {
                            const value = e.target.value;

                            if (/^\d*$/.test(value)) {
                              setPropertyRent(value);
                            }
                          }}
                        />
                        <span>/mo</span>
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
            {showEffortRateCalcuator ? (
              <div className="effort-rate-table">
                <div className="effort-rate-table-heading">
                  <p
                    className="text-left"
                    onClick={() => setTotalIncomeModal(true)}
                  >
                    {_t("category")}
                  </p>
                  <p>{_t("monthlyNetIncome")}</p>
                  <p>{_t("effortRate")}</p>
                </div>
                <div
                  className={`effort-rate-table-info ${
                    isGuarantor ? "text_disabled" : ""
                  }`}
                >
                  <p
                    onClick={() => {
                      const sourceObj = isGuarantor
                        ? allGuarantorSources
                        : [
                            {
                              _id: userIncome?.all_sources?._id,
                              all_sources: userIncome?.all_sources,
                              current_selected: userIncome?.source,
                              current_income_mode: userIncome?.source_mode,
                              type: "tenant",
                            },
                          ];
                      setUpdateSourceObj(sourceObj);
                      setUpdateIncomeSourceModal(true);
                    }}
                    className={`cursor-pointer d-flex justify-content-start gap-2 align-items-center ${
                      !isGuarantor ? "text-decoration-underline" : ""
                    }`}
                  >
                    {_t("tenant")}
                    <img
                      className="Imagerutate ImageSizeSet"
                      src={VectorIcon}
                      alt="Vector Icon"
                    />
                  </p>
                  <p>
                    €
                    {convertCurrencyFormat(
                      isGuarantor
                        ? totalGurantorIncomeForTable
                        : userIncome?.amount
                    )}
                  </p>
                  <p
                    style={{
                      color: getEffortColor(
                        getRentPercentage(
                          isGuarantor
                            ? totalGurantorIncomeForTable
                            : userIncome?.amount,
                          propertyRent
                        )?.roundValue
                      ),
                    }}
                  >
                    {propertyRent
                      ? `${
                          getRentPercentage(
                            isGuarantor
                              ? totalGurantorIncomeForTable
                              : userIncome?.amount,
                            propertyRent
                          )?.roundValue ?? "0"
                        }%`
                      : "-"}
                  </p>
                </div>
                <div
                  className={`effort-rate-table-info ${
                    isGuarantor
                      ? ""
                      : user?.gurantor_id?.filter(
                            (val) => val?.forensic_status === "COMPLETED"
                          )?.length == 0
                        ? "text_disabled"
                        : ""
                  }`}
                >
                  <p
                    onClick={() => {
                      const sourceObj = isGuarantor
                        ? [
                            {
                              _id: userIncome?.all_sources?._id,
                              all_sources: userIncome?.all_sources,
                              current_selected: userIncome?.source,
                              current_income_mode: userIncome?.source_mode,
                              type: "tenant",
                            },
                          ]
                        : allGuarantorSources;
                      setUpdateSourceObj(sourceObj);
                      setUpdateIncomeSourceModal(true);
                    }}
                    className={`cursor-pointer d-flex justify-content-start gap-2 align-items-center ${
                      isGuarantor
                        ? "text-decoration-underline"
                        : user?.gurantor_id?.filter(
                              (val) => val?.forensic_status === "COMPLETED"
                            )?.length > 0
                          ? "text-decoration-underline"
                          : ""
                    }`}
                  >
                    {_t("guarantors")}
                    <img
                      className="Imagerutate ImageSizeSet"
                      src={VectorIcon}
                      alt="Vector Icon"
                    />
                  </p>
                  <p>
                    €
                    {convertCurrencyFormat(
                      isGuarantor
                        ? userIncome?.amount
                        : totalGurantorIncomeForTable
                    )}
                  </p>
                  <p
                    style={{
                      color: getEffortColor(
                        getRentPercentage(
                          isGuarantor
                            ? userIncome?.amount
                            : totalGurantorIncomeForTable,
                          propertyRent
                        )?.roundValue ?? "0"
                      ),
                    }}
                  >
                    {propertyRent
                      ? `${
                          getRentPercentage(
                            isGuarantor
                              ? userIncome?.amount
                              : totalGurantorIncomeForTable,
                            propertyRent
                          )?.roundValue ?? "0"
                        }%`
                      : "-"}
                  </p>
                </div>
                <div
                  className={`effort-rate-table-info border-0 ${
                    user?.gurantor_id?.filter(
                      (val) => val?.forensic_status === "COMPLETED"
                    )?.length == 0
                      ? "text_disabled"
                      : ""
                  }`}
                >
                  <p className="text-left">{_t("combined")}</p>
                  <p>€{convertCurrencyFormat(combinedIncomeForTable)}</p>
                  <p
                    style={{
                      color: getEffortColor(
                        getRentPercentage(combinedIncomeForTable, propertyRent)
                          ?.roundValue
                      ),
                    }}
                  >
                    {propertyRent
                      ? `${
                          getRentPercentage(
                            combinedIncomeForTable,
                            propertyRent
                          )?.roundValue ?? "0"
                        }%`
                      : "-"}
                  </p>
                </div>
                {llShowOnly && showEffortRateCalcuator && (
                  <div
                    className="cursor-pointer d-flex align-items-center justify-content-end custom-gap-2 arrow-right-wrapper"
                    onClick={() => setShowEffortRateCalcuator(false)}
                  >
                    <img
                      src={VectorIcon}
                      alt="Vector Icon"
                      className="TwotoneIcon"
                    />
                    <p className="Profileheading_change">
                      {_t("backToPreviousView")}
                    </p>
                  </div>
                )}
              </div>
            ) : (
              <div>
                <div>
                  <div
                    className="skormeter vw-mt-4 w-100 position-relative"
                    style={{
                      "--w": ((efforRateLocal - min) / (max - min)) * 100,
                    }}
                  >
                    <Slider
                      min={min}
                      max={max}
                      value={efforRateLocal}
                      onChange={handleChangeEffortRate}
                      onChangeComplete={handleChangeEffortRateApiCall}
                      draggableTrack={true}
                    />
                    <div className="slider-labels">
                      <span>{_t("affordable")}</span>
                      <span></span>
                      <span>{_t("stretching")}</span>
                      <span></span>
                      <span>{_t("risk")}</span>
                    </div>
                  </div>
                </div>
                <div className="row effortRateIncomeWrapper vw-mt-4">
                  <div className="col-md-6">
                    <div className="col incomeDiv incomeDiv2 d-flex justify-content-between align-items-center border-0">
                      <div className="d-flex justify-content-between align-items-end w-100">
                        <div
                          style={{ width: "100%" }}
                          className="d-flex justify-content-between align-items-center income_info_card"
                        >
                          <div className="Twotone_img d-flex align-items-center justify-content-center">
                            <img
                              src={Twotone2}
                              alt="Vector Icon"
                              className="TwotoneIcon"
                            />
                          </div>
                          <div style={{ width: "100%" }}>
                            <p className="Profileheading_change profile-mb d-flex align-items-center gap-2">
                              <span
                                onClick={() => {
                                  if (!llShowOnly) {
                                    return;
                                  }
                                  const sourceObj =
                                    effortRateType === "tenant" || isGuarantor
                                      ? //  only tenant income
                                        [
                                          {
                                            _id: userIncome?.all_sources?._id,
                                            all_sources:
                                              userIncome?.all_sources,
                                            current_selected:
                                              userIncome?.source,
                                            current_income_mode:
                                              userIncome?.source_mode,
                                            type: "tenant",
                                          },
                                        ]
                                      : effortRateType === "guarantor"
                                        ? // only guarantors income
                                          allGuarantorSources
                                        : // both tenant and guarantors income
                                          [
                                            {
                                              _id: userIncome?.all_sources?._id,
                                              all_sources:
                                                userIncome?.all_sources,
                                              current_selected:
                                                userIncome?.source,
                                              current_income_mode:
                                                userIncome?.source_mode,
                                              type: "tenant",
                                            },
                                            ...allGuarantorSources,
                                          ];
                                  setUpdateSourceObj(sourceObj);
                                  setUpdateIncomeSourceModal(true);
                                }}
                                className={`d-flex align-items-center custom-gap-1 ${
                                  llShowOnly
                                    ? "text-decoration-underline cursor-pointer"
                                    : ""
                                }`}
                              >
                                {_t("averageMonthlyNetIncome")}
                                <img
                                  src="/images/arrow-right.svg"
                                  alt="Vector Icon"
                                  className="arrow-back-icon"
                                />
                              </span>
                              <div className="d-flex align-items-center gap-1">
                                <img
                                  src={UserIcon}
                                  alt="Vector Icon"
                                  className="vactorImg vactorImg1"
                                />
                                <p className="length-text">
                                  {(() => {
                                    const tenantCount =
                                      effortRateType === "tenant" ||
                                      effortRateType === "both"
                                        ? 1
                                        : 0;

                                    let guarantorCount =
                                      effortRateType === "guarantor" ||
                                      effortRateType === "both"
                                        ? (user?.gurantor_id?.length ?? 0)
                                        : 0;
                                    if (isGuarantor) {
                                      guarantorCount = 1;
                                    }

                                    return tenantCount + guarantorCount;
                                  })()}
                                </p>
                              </div>
                            </p>
                            <div className="d-flex justify-content-between align-items-center">
                              <p className="Profileheading_change3">
                                €{convertCurrencyFormat(combinedIncome ?? 0)}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="col incomeDiv incomeDiv2 d-flex justify-content-between align-items-center border-0">
                      <div className="d-flex justify-content-between align-items-center w-100">
                        <div
                          style={{ width: "100%" }}
                          className="d-flex justify-content-between align-items-center income_info_card"
                        >
                          <div className="Twotone_img d-flex align-items-center justify-content-center">
                            <img
                              src={"/images/max-rent-icon.svg"}
                              alt="Vector Icon"
                              className="TwotoneIcon"
                            />
                          </div>
                          <div className="profile_heading_width ">
                            <p className="Profileheading_change profile-mb d-flex align-items-center custom-gap-2">
                              {_t("monthlyPayment")}

                              {llShowOnly && (
                                <>
                                  <img
                                    data-tooltip-id="details-skor-tooltip"
                                    src={moreInfoimg}
                                    alt="Vector Icon"
                                    className="vactorImg vactorImg1"
                                  />
                                  <ReactTooltip
                                    id="details-skor-tooltip"
                                    place="bottom"
                                    noArrow
                                    className="react-tooltip-styling details-skor-tooltip"
                                    render={() => (
                                      <p>
                                        {_t(
                                          "toEnsureFinacialStabilityWeRecommendAMaximumEffortRateOf35StayingWithinThisThresholdIsStandardPraticeInSpainToEnsureAffordabilityAndMinimizeRiskForBothParties"
                                        )}
                                      </p>
                                    )}
                                  />
                                </>
                              )}
                            </p>
                            <div className="d-flex gap-2 align-items-center">
                              <p className="Profileheading_change3">
                                €
                                {!Number.isNaN(effortRateData?.effort_amount)
                                  ? convertCurrencyFormat(
                                      Math.round(
                                        Number(effortRateData.effort_amount)
                                      )
                                    )
                                  : 0}
                              </p>
                              <p
                                style={{
                                  fontWeight: "700",
                                  color: getEffortColor(efforRateLocal),
                                }}
                                className="Profileheading_change"
                              >
                                {`(${Math.round(efforRateLocal)}% ${_t(
                                  "effortRate"
                                )})`}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {llShowOnly && (
                    <div
                      className="cursor-pointer d-flex align-items-center justify-content-end custom-gap-2 arrow-right-wrapper"
                      onClick={() => setShowEffortRateCalcuator(true)}
                    >
                      <p className="Profileheading_change">
                        {_t("effortRateCalculator")}
                      </p>
                      <img
                        src={VectorIcon}
                        alt="Vector Icon"
                        style={{ rotate: "-180deg" }}
                        className="TwotoneIcon"
                      />
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
        <div className="col-md-6">
          {haveValue(scoreValue) ? (
            <div
              className="Profile_summary2 skorsetbox position-relative p-3 meterMainContainer"
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
              style={{ overflow: "hidden" }}
            >
              {isSkorExpired && (
                <div className="bankConnectExpireContainer d-flex align-items-start justify-content-between">
                  <p className="expiredText d-flex align-items-center justify-content-center">
                    <img src={notIcon} className="notIcon" />
                    {_t("expired")}
                  </p>
                  <div className="h-100 bankExpiresContent d-flex flex-column align-items-start justify-content-center">
                    <p>
                      {llShowOnly
                        ? _t(
                            "skorValidityForThisTenantHasBeenExpiredSendAReminderToTheTenantToReverifyTheirBankToContinueBeingSkored"
                          )
                        : _t(
                            "yourFinancialSkorVallidityHasExpiredPleaseReVerifyYourBankToContiueBeingSkored"
                          )}
                    </p>
                    {showReportIcons && (
                      <>
                        {llShowOnly &&
                        WORKSPACE_ROLES_CAPABILITIES?.tenants?.interactionRoles?.includes(
                          originalUser?.current_workspace_role
                        ) ? (
                          <button
                            disabled={sendRemainderLoading}
                            onClick={() =>
                              handleSendRemainder("forExpiryFinancialData")
                            }
                            className="send-reminder-button"
                          >
                            {sendRemainderLoading
                              ? `${_t("sending")}...`
                              : _t("sendRemainder")}
                          </button>
                        ) : (
                          <button
                            onClick={() => {
                              setBankshow(true);
                              setReconnectFlow(true);
                            }}
                            className="send-reminder-button"
                          >
                            {_t("reconnectBank")}
                          </button>
                        )}
                      </>
                    )}
                  </div>
                </div>
              )}
              <div className={llShowOnly ? "" : "d-flex"}>
                <h4 className={llShowOnly ? "text-end" : "text-start"}>
                  {_t("financialSkor")}
                </h4>
                {!llShowOnly && (
                  <button
                    onClick={() => {
                      setBankshow(true);
                      setReconnectFlow(true);
                    }}
                    className="addGuarantorButton reconnectBank me-0 d-flex align-items-center justify-content-center hideOnMobile"
                  >
                    {_t("reconnectBank")}
                  </button>
                )}
              </div>
              <div className="row">
                <div className="col-5 col-md-6">
                  <div
                    style={{
                      position: "relative",
                      marginTop: isSkorExpired && ".8333vw",
                    }}
                    className="skorSetWrapper"
                  >
                    {/* SVG Gradient (hidden but used via URL) */}
                    <svg
                      style={{ height: "0", position: "absolute", top: "0" }}
                    >
                      <defs>
                        <linearGradient
                          id="progressGradient"
                          x1="0%"
                          y1="0%"
                          x2="100%"
                          y2="0%"
                        >
                          <stop
                            offset="100%"
                            stopColor={getProgressColor(value)}
                          />
                        </linearGradient>
                      </defs>
                    </svg>
                    <div
                      // className="skorr"
                      className={llShowOnly ? "skorr cursor-pointer" : "skorr"}
                      onClick={() => {
                        if (
                          llShowOnly &&
                          WORKSPACE_ROLES_CAPABILITIES?.tenants?.interactionRoles?.includes(
                            originalUser?.current_workspace_role
                          ) &&
                          user?.bank_details?.userDataByProvider?.[0]
                            ?.providerName !== "Uploaded from CSV"
                        )
                          handleOpenFinancialInfoModal();
                      }}
                    >
                      <CircularProgressbarWithChildren
                        value={value}
                        maxValue={100}
                        circleRatio={0.78}
                        styles={buildStyles({
                          rotation: 0.61,
                          strokeLinecap: "round",
                          trailColor: "#e6f0e9",
                          textColor: "#1c1c1c",
                          pathTransitionDuration: 0.5,
                          pathColor: getProgressColor(value),
                        })}
                      >
                        <div className="skills">
                          <div
                            style={{ textAlign: "center", lineHeight: "1.8vw" }}
                          >
                            <div
                              style={{
                                fontSize: "1.829vw",
                                fontWeight: "800",
                                color: "#253837",
                              }}
                            >
                              {scoreValue}
                            </div>
                            <div
                              style={{ fontSize: "0.854vw", color: "#7F7F7F" }}
                              className="skoroutoftext"
                            >
                              /{maxValue}
                            </div>
                          </div>
                          <div className="skoreset">
                            <div
                              className="skorstart"
                              style={{
                                fontSize: "0.854vw",
                                fontWeight: "500",
                                color: "##7F7F7F",
                              }}
                            >
                              0
                            </div>
                            <div
                              style={{
                                fontSize: "0.854vw",
                                fontWeight: "500",
                                color: "##7F7F7F",
                              }}
                              className="skorend"
                            >
                              {maxValue}
                            </div>
                          </div>
                        </div>
                      </CircularProgressbarWithChildren>
                    </div>
                  </div>
                </div>

                <div className="col-7 col-md-6 skorSetDetailsWrapper">
                  <div>
                    <p className="style1">{_t("scoreStatus")}:</p>
                    {returnSkorStatus()}
                  </div>
                  <div className="row mb-2 about-finical-skor">
                    <div className="col-6">
                      <p className="style1">{_t("createdOn")}:</p>
                      <p className="style2">
                        {moment(
                          haveValue(user?.bankVerificationDate)
                            ? user?.bankVerificationDate
                            : user?.created_at
                        ).format("DD-MM-YYYY")}
                      </p>
                    </div>
                    <div className="col-6">
                      <p className="style1">{_t("validTill")}:</p>
                      <p className="style2">
                        {moment(
                          haveValue(user?.bankVerificationDate)
                            ? user?.bankVerificationDate
                            : user?.created_at
                        )
                          .add(2, "months")
                          .format("DD-MM-YYYY")}
                      </p>
                    </div>
                  </div>
                  <div className="about-finical-skor">
                    <p className="style1">{_t("accountHolder")}:</p>
                    <p className="style2 fw-bold">
                      {haveValue(
                        user?.bank_details?.userDataByProvider[0]?.accounts[0]
                          ?.holderName
                      )
                        ? user?.bank_details?.userDataByProvider[0]?.accounts[0]
                            ?.holderName
                        : `${user?.fname} ${user?.lname}`}
                    </p>
                  </div>
                  <div className="bank-account-text-wrapper">
                    {user?.ie_verified &&
                    !haveValue(user?.paymentScores?.creditScore?.value) ? (
                      <p className="style1">{_t("skorBasedOnIEProfile")} </p>
                    ) : (
                      <p className="style1">
                        {haveValue(
                          user?.bank_details?.userDataByProvider?.[0]
                            ?.providerName
                        ) &&
                        user?.bank_details?.userDataByProvider?.[0]
                          ?.providerName === "Uploaded from CSV"
                          ? _t("bankStatementUsedForScoring")
                          : _t("bankAccountUsedForScoring")}
                        {haveValue(
                          user?.bank_details?.userDataByProvider?.[0]
                            ?.accounts?.[0]?.iban
                        ) &&
                          ` *${user?.bank_details?.userDataByProvider?.[0]?.accounts?.[0]?.iban?.slice(
                            -4
                          )}`}
                      </p>
                    )}
                    {llShowOnly &&
                      user?.bank_details?.userDataByProvider?.[0]
                        ?.providerName !== "Uploaded from CSV" &&
                      (isSkorExpired ? (
                        <div
                          class={`meterGifWrapper w-100 d-flex justify-content-end align-items-center`}
                        >
                          <img src="/images/gif-image.svg" />
                        </div>
                      ) : !isHovered ? (
                        <div
                          class={`meterGifWrapper w-100 d-flex justify-content-end align-items-center`}
                          onClick={() => {
                            if (
                              llShowOnly &&
                              !isSkorExpired &&
                              WORKSPACE_ROLES_CAPABILITIES?.tenants?.interactionRoles?.includes(
                                originalUser?.current_workspace_role
                              )
                            )
                              handleOpenFinancialInfoModal();
                          }}
                        >
                          <img src="/gif/meter.gif" />
                        </div>
                      ) : (
                        <div className="animated-button-wrapper w-100 d-flex justify-content-end align-items-center">
                          <div
                            className="animated-button"
                            onClick={() => {
                              if (
                                llShowOnly &&
                                !isSkorExpired &&
                                WORKSPACE_ROLES_CAPABILITIES?.tenants?.interactionRoles?.includes(
                                  originalUser?.current_workspace_role
                                )
                              )
                                handleOpenFinancialInfoModal();
                            }}
                          >
                            <img
                              src="/images/meter-icon-green-bg.svg"
                              alt="icon"
                              className="animated-button-icon"
                            />
                            <p>{_t("skorDetails")}</p>
                            <img
                              src="/images/arrow-right-white.svg"
                              alt="arrow"
                              className="arrow-right"
                            />
                          </div>
                        </div>
                      ))}
                  </div>
                  {!llShowOnly && (
                    <button
                      onClick={() => {
                        setBankshow(true);
                        setReconnectFlow(true);
                      }}
                      className="addGuarantorButton reconnectBankMobile reconnectBank me-0 d-flex align-items-center justify-content-center hideOnDesktop"
                    >
                      {_t("reconnectBank")}
                    </button>
                  )}
                </div>
              </div>
            </div>
          ) : llShowOnly ? (
            <LandlordBankCard
              showReportIcons={showReportIcons}
              sendRemainderLoading={sendRemainderLoading}
              isUserTenantCheck={isUserTenantCheck}
              handleSendRemainder={handleSendRemainder}
              user={user}
              financial_info_errors={financial_info_errors}
            />
          ) : (
            <ConnectBankCard
              user={user}
              setBankshow={setBankshow}
              isGuarantor={isGuarantor}
              paymentScoreLoading={paymentScoreLoading}
              setReconnectFlow={setReconnectFlow}
              financial_info_errors={financial_info_errors}
            />
          )}
        </div>
      </div>

      <TotalSalaryModal
        isOpen={totalIncomeModal}
        onClose={() => setTotalIncomeModal(false)}
        handleUpdateSource={() => {
          setTotalIncomeModal(false);
          setUpdateIncomeSourceModal(true);
        }}
        user={user}
        effortObj={effortObj}
        userIncome={userIncome}
        gurantorsIncome={gurantorsIncome}
        setUpdateSourceObj={{}}
        showReportIcons={showReportIcons}
        llShowOnly={llShowOnly}
        profileId={profileId}
        disabledIncomeSourcesFromDb={excluded_income_source_ids}
        loadFullInfo={loadFullInfo}
        isFromReport={isFromReport}
      />
      {updateIncomeSourceModal && (
        <UpdatedIncomeSourceModal
          show={updateIncomeSourceModal}
          onHide={() => {
            setUpdateIncomeSourceModal(false);
          }}
          updateSourceList={updateSourceObj}
          handleIncomeChange={handleIncomeChange}
          loadFullInfo={loadFullInfo}
          savedCustomSources={fullinfo?.custom_income_sources}
          handleDeleteCustomIncome={handleDeleteCustomIncome}
        />
      )}
      {Bankshow && (
        <BankModal
          user={user}
          formHandler={() => {}}
          updateUserProfile={updateTenantData}
          isGuarantor={isGuarantor}
          loadGuarantorData={() => {}}
          guarantor_a_id={null}
          usedFor={"popup"}
          setBankshow={setBankshow}
          loadFullInfo={loadFullInfo}
          setPaymentScoreLoading={setPaymentScoreLoading}
          reconnectFlow={reconnectFlow}
          setReconnectFlow={setReconnectFlow}
          getAnalysisDetails={getAnalysisDetails}
          setScoreValue={setScoreValue}
          setFinancial_info_errors={setFinancial_info_errors}
        />
      )}
      <FinancialInfoModal
        user={user}
        finData={user?.tenant_extra_field_id?.tink_report_data}
        isOpen={financialInfoModal}
        onClose={() => setFinancialInfoModal(false)}
        handleFinancialIncomeChange={handleFinancialIncomeChange}
        storedFinancialData={selectedFinancialIncomeSourceData}
        selectedSources={selectedSources}
        setSelectedSources={setSelectedSources}
      />
    </>
  );
};

export default DetailsSkor;
